import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface DataFilterConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const DataFilterConfig: React.FC<DataFilterConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Szűrés beállítások">
        <ConfigField
          label="Szűrési mód"
          description="Hogyan szűrje az adatokat"
        >
          <select
            value={node.data.config?.filterMode || 'condition'}
            onChange={(e) => updateConfig('filterMode', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="condition">Feltétel alapján</option>
            <option value="unique">Egyedi értékek</option>
            <option value="null">Null értékek kiszűrése</option>
            <option value="empty">Üres értékek kiszűrése</option>
          </select>
        </ConfigField>

        {node.data.config?.filterMode === 'condition' && (
          <>
            <ConfigField
              label="Mező neve"
              description="A szűrendő mező"
            >
              <input
                type="text"
                value={node.data.config?.fieldName || ''}
                onChange={(e) => updateConfig('fieldName', e.target.value)}
                placeholder="name, age, status..."
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
              />
            </ConfigField>

            <ConfigField
              label="Operátor"
              description="Szűrési feltétel"
            >
              <select
                value={node.data.config?.operator || '=='}
                onChange={(e) => updateConfig('operator', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
              >
                <option value="==">Egyenlő (==)</option>
                <option value="!=">Nem egyenlő (!=)</option>
                <option value=">">Nagyobb (&gt;)</option>
                <option value="<">Kisebb (&lt;)</option>
                <option value=">=">Nagyobb vagy egyenlő (&gt;=)</option>
                <option value="<=">Kisebb vagy egyenlő (&lt;=)</option>
                <option value="contains">Tartalmazza</option>
                <option value="startsWith">Ezzel kezdődik</option>
                <option value="endsWith">Ezzel végződik</option>
              </select>
            </ConfigField>

            <ConfigField
              label="Érték"
              description="Összehasonlítási érték"
            >
              <input
                type="text"
                value={node.data.config?.value || ''}
                onChange={(e) => updateConfig('value', e.target.value)}
                placeholder="Keresett érték vagy {{variable}}"
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
              />
            </ConfigField>
          </>
        )}

        <div className="flex items-center">
          <input
            type="checkbox"
            id="caseSensitive"
            checked={node.data.config?.caseSensitive || false}
            onChange={(e) => updateConfig('caseSensitive', e.target.checked)}
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
          <label htmlFor="caseSensitive" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Kis/nagybetű érzékeny
          </label>
        </div>
      </ConfigSection>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-3">
        <div className="text-xs text-blue-700 dark:text-blue-300">
          <strong>🔍 Adatszűrés:</strong>
          <br />• Tömb elemek szűrése feltétel alapján
          <br />• Eredmény: <code>{'{{filtered}}'}</code>
          <br />• Példa: <code>age &gt; 18</code>
        </div>
      </div>
    </div>
  );
};

export default DataFilterConfig;
